<template >
  <v-layout>
    <v-panel
      contextual-style="primary"
    >
      <h1 class="panel-title" slot="heading">
        User Administration <button @click="adduser()" style="float: right;" class="btn btn-xs btn-info">Add User</button>
      </h1>
      <div slot="body">

        <table class="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>E-Mail</th>
              <th>Roles</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:class="{'editable': thisuser.type !== 'global'}" @click="selectUser(thisuser)" v-for="thisuser, userindex in $store.state.account.userlist">
              <td>{{ thisuser.name }}</td>
              <td>{{ thisuser.email }}</td>
              <td><span v-for="thisrole in $store.state.account.userlist[userindex].roles"><button class="btn btn-xs btn-info">{{ thisrole }}</button>&nbsp;</span></td>
              <td><button class="btn btn-xs btn-warning">Edit</button></td>
            </tr>
          </tbody>
        </table>

      </div>
    </v-panel>
  </v-layout>
</template>
<script>

import Vue from 'vue';
import acctService from '../../../services/account';
import store from '../../../store';

export default {
  data() {
    return {
      doingSomething: false,
      formdata: {
      },
    };
  },
  methods: {
    adduser() {
      Vue.router.push({
        name: 'admin.user-edit',
      });
    },
    refresh() {
      // console.log('store.auth.selected_sp');
      // console.log(store.state.auth.selected_sp.sp_id);
      acctService.getusers(store.state.auth.selected_sp.sp_id);
    },
    selectUser(thisuser) {
      if (!thisuser || !thisuser.user_id) {
        return;
      }
      Vue.router.push({
        name: 'admin.user-edit',
        params: {
          user_id: thisuser.user_id,
        },
      });
    },
  },
  beforeMount() {
    this.refresh();
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};

</script>
<style>
tr.editable:hover {
  background: #eeeef2;
  /*cursor:context-menu;*/
  cursor:pointer;
}
td.green {
  color: #00aa00;
}
span.readonly {
  color: #aaaaaa;
}
td.red {
  color: #aa0000;
}
</style>



// WEBPACK FOOTER //
// index.vue?7ab97f32